import { Format, StyleColor } from '../../../utils/styles-constants';
import styled from 'styled-components';
import { Button } from '../../../components/Button/styles';
import { ButtonHTMLAttributes } from 'react';

export const StyledDriveItemDetail = styled('div')`
	font-size: 14px;
	color: ${StyleColor.Black};
	background: ${StyleColor.White};
	min-height: 100%;
`;

export const Container = styled('div')`
	margin: 0 auto;
	max-width: 100%;
	padding: 0 15px;

	@media ${Format.Tablet} {
		width: 720px;
	}

	@media ${Format.SmallDesktop} {
		width: 960px;
	}

	@media ${Format.LargeDesktop} {
		width: 1140px;
	}
`;

export const Header = styled('div')`
	border-bottom: 1px solid ${StyleColor.Grey100};
	background: ${StyleColor.Blue100};
	padding: 15px 0;
`;

export const HeaderInner = styled('div')`
	display: flex;
	align-items: center;

	> svg {
		height: 180px;
		width: 180px;
		fill: ${StyleColor.Grey500};
		margin-right: 30px;

		@media ${Format.Smartphone} {
			width: 120px;
		}
	}
`;

export const ActionButtons = styled('div')`
	border-bottom: 1px solid ${StyleColor.Grey100};
`;

export const ActionButtonsInner = styled('div')`
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
`;

export const StandardButton = styled(Button)`
	margin: 20px 5px;
	${(props: ButtonHTMLAttributes<HTMLButtonElement>) => props.disabled
		? `cursor: auto;
			border: 1px solid ${StyleColor.Grey400};
			color: ${StyleColor.White};
			background-color: ${StyleColor.Grey400};
			font-size: 14px;

			@media ${Format.Smartphone} {
				flex-basis: 25%;
			}
		`
		: `	@media ${Format.Smartphone} {
				flex: 0 1 50%;
			}`}
`;

const mediaCommonStyle = `
	height: 180px;
	width: 180px;
	margin-right: 30px;
	flex-shrink: 0;

	@media ${Format.Smartphone} {
		height: 120px;
		width: 120px;
		margin-right: 20px;
	}
`;

interface BackgroundImageProps {
	src: string;
}

export const BackgroundImage = styled('div')`
	background-image: url("${(props: BackgroundImageProps) => props.src}");
	background-size: cover;
    background-position: 50% 50%;
	${mediaCommonStyle}
`;

export const TitleContainer = styled('div')`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	justify-content: center;
`;

export const Title = styled('div')`
	font-size: 18px;
	overflow: hidden;
	word-break: break-word;
	margin-bottom: 5px;
`;

export const SubTitle = styled('div')`
	font-size: 12px;
	overflow: hidden;
	word-break: break-all;
`;

export const DescriptionRow = styled('div')`
	border-bottom: 1px solid ${StyleColor.Grey100};
	padding: 40px 0;
`;

export const DescriptionLabel = styled('div')`
	color: ${StyleColor.Black};
	font-weight: 600;
	margin-bottom: 30px;
`;

export const DescriptionText = styled('div')`
	color: ${StyleColor.Grey400};
	font-size: 13px;
`;

export const InfoRow = styled('div')`
	border-bottom: 1px solid ${StyleColor.Grey100};
	padding: 20px 0;
	display: flex;
	align-items: center;
`;

export const InfoLabel = styled('div')`
	color: ${StyleColor.Black};
	font-weight: 600;
	flex-shrink: 0;
	margin: 0 10px;
`;

interface InfoTextProps {
	uppercase: boolean;
}

export const InfoText = styled('div')`
	flex-grow: 1;
	text-align: right;
	${ (props: InfoTextProps) => props.uppercase ? 'text-transform: uppercase;' : '' }
`;

export const DriveItemActionIcons = styled('div')`
	display: flex;
	justify-content: flex-end;

	svg {
		transition: all 0.2s;
		fill: ${props => props.theme.primary.iconsColor};
	}
`;

export const PublicationCoverContainer = styled('div')`
	display: flex;
	margin: 30px 0 0 0;
	flex-wrap: nowrap;
	overflow: auto;
`;

export const PublicationCoverImage = styled('img')`
	height: 180px;
	width: auto;
	margin: 0 20px 30px 0;
	flex-shrink: 0;

	@media ${Format.Tablet} {
		height: 210px;
	}

	@media ${Format.SmallDesktop} {
		height: 230px;
	}

	@media ${Format.LargeDesktop} {
		height: 260px;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/Detail/styles.ts